import type { mmComponent } from "@/types";

type ComponentConstructor<TOptions> = new (element: HTMLElement, options?: TOptions) => mmComponent<TOptions>;

export function registerComponent<TOptions>(name: string, component: ComponentConstructor<TOptions>): void {
  (function ($) {
    ($.fn as Record<string, unknown>)[name] = function (options: TOptions | "instance") {
      if (options === "instance") {
        return $(this).data(name) as mmComponent<TOptions>;
      }

      return $(this).each(function(this: HTMLElement) {
        const element = this;
        const instance = new component(element, options);
        $(this).data(name, instance);
      });
    };
  })(jQuery);
}
